/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['underscore'], function(_) {

	_.deepClone = function(obj) {
		// This is the fastest way to clone an object in javascript.
		return JSON.parse(JSON.stringify(obj));
	};

});